'use client'
import * as React from 'react'
import Button from '../../Button'
import icons from '../../icons'
import { constants } from '../../../constants'
import { isBrowser } from '../../../utils/isBrowser'

const BlogSocialShare = () => {
    const socials = constants['socials']
    return (
        <div className="gap-2 lg:gap-[30px] flex-row flex justify-between lg:justify-start items-center my-20 border-t-[1px] border-b-[1px] border-grey/20 py-[30px]">
            <p id="socialPopover" className="tracking-[1px] font-Chaney uppercase text-[16px] leading-[32px]">
                Deel dit artikel
            </p>
            <div className="flex gap-2">
                {socials.map(social => {
                    if (social.shareUrl) {
                        return (
                            <Button
                                className="btn-round bg-green-brand [&>span>svg>path]:fill-dark w-12 h-12 [&>span>svg]:w-4 [&>span>svg]:h-4"
                                as="a"
                                target="_blank"
                                rel="noopener noreferrer"
                                href={social.shareUrl(isBrowser ? location.href : '')}
                                key={social.link}
                                aria-label={`Deel deze blog via ${social.icon}`}
                            >
                                {social.icon && icons[social.icon]}
                            </Button>
                        )
                    } else {
                        ;<></>
                    }
                })}
            </div>
        </div>
    )
}

export default BlogSocialShare
